import { render, staticRenderFns } from "./testTips.vue?vue&type=template&id=3dc583af&scoped=true&"
import script from "./testTips.vue?vue&type=script&lang=js&"
export * from "./testTips.vue?vue&type=script&lang=js&"
import style0 from "./testTips.vue?vue&type=style&index=0&id=3dc583af&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc583af",
  null
  
)

export default component.exports